export const hideToasts = !!process.env.REACT_APP_HIDE_TOASTS
export const adultAge = process.env.REACT_APP_ADULT_AGE || 18

export const couponPrefix = '00'

export const maxCouponNumberLength = 19

export const ticketCancelReasonMaxLength = 155

export const redZoneBrandIds = [5, 6, 7, 13, 14]
export const greenZoneBrandIds: number[] = []
export const blueZoneBrandIds: number[] = []

export type BrandInfo = {
  brandId: number
  countryCode: string
  nativeName: string
  released: boolean
  showTax: boolean
  excluded?: boolean
  customTitle?: string
  customDescription?: string
  isBetInShopDisabled?: boolean
  isBetInShopCombiEnabled?: boolean
  isPlayCombiEnabled?: boolean
  redirectToResultsPage?: boolean
  hideTicketOnPage?: boolean
  loginAvailable?: boolean
  customLogo?: boolean
  loginButtonTicket?: boolean
  disabledPayAndPlay?: boolean
  voluumIntegrationEnabled?: boolean
  iwgAsMainPage?: boolean
}

export const brandsInfo: BrandInfo[] = [
  {
    brandId: 6,
    countryCode: 'CM',
    nativeName: 'Cameroun',
    released: true,
    showTax: false,
    customTitle: 'Loto',
    customDescription: 'Loto Premierbet',
    loginAvailable: true,
    loginButtonTicket: true,
    disabledPayAndPlay: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: true,
    isPlayCombiEnabled: true,
  },
  {
    brandId: 2,
    countryCode: 'GH',
    nativeName: 'Ghana',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 13,
    countryCode: 'MZ',
    nativeName: 'Moçambique',
    released: false,
    excluded: true,
    showTax: true,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isBetInShopDisabled: true,
    disabledPayAndPlay: false,
    loginAvailable: true,
    loginButtonTicket: true,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 5,
    countryCode: 'CG',
    nativeName: 'Brazzaville',
    released: false,
    excluded: true,
    showTax: false,
    customTitle: 'Loto',
    customDescription: 'Loto Premierbet',
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 19,
    countryCode: 'GN',
    nativeName: 'Guinée',
    released: true,
    excluded: false,
    showTax: false,
    customTitle: 'Loto',
    customDescription: 'Guinee Loto Zone',
    loginAvailable: true,
    isBetInShopDisabled: false,
    customLogo: true,
    loginButtonTicket: true,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: true,
  },
  {
    brandId: 16,
    countryCode: 'NG',
    nativeName: 'Nigeria',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 21,
    countryCode: 'NG',
    nativeName: 'Nigeria',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 4,
    countryCode: 'CD',
    nativeName: 'RD Congo',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 7,
    countryCode: 'MW',
    nativeName: 'Malawi',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: true,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 15,
    countryCode: 'RW',
    nativeName: 'Rwanda',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 12,
    countryCode: 'GA',
    nativeName: 'Gabon',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 8,
    countryCode: 'ML',
    nativeName: 'Mali',
    released: false,
    excluded: true,
    showTax: false,
    isBetInShopDisabled: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 9,
    countryCode: 'SN',
    nativeName: 'Sénégal',
    released: false,
    excluded: true,
    showTax: false,
    isBetInShopDisabled: true,
    redirectToResultsPage: true,
    hideTicketOnPage: true,
    customLogo: true,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 18,
    countryCode: 'SL',
    nativeName: 'Sierra Leone',
    released: false,
    excluded: true,
    showTax: true,
    isBetInShopDisabled: true,
    voluumIntegrationEnabled: true,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 10,
    countryCode: 'TZ',
    nativeName: 'Tanzania',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 14,
    countryCode: 'TD',
    nativeName: 'Tchad',
    released: false,
    excluded: true,
    showTax: false,
    customTitle: 'Loto',
    customDescription: 'Loto Premierbet',
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 1,
    countryCode: 'UG',
    nativeName: 'Uganda',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 17,
    countryCode: 'AO',
    nativeName: 'Angola',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 3,
    countryCode: 'KE',
    nativeName: 'Kenya',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 11,
    countryCode: 'ZM',
    nativeName: 'Zambia',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
  {
    brandId: 23,
    countryCode: 'TG',
    nativeName: 'Togo',
    released: false,
    excluded: true,
    showTax: false,
    voluumIntegrationEnabled: true,
    iwgAsMainPage: false,
    isBetInShopCombiEnabled: false,
    isPlayCombiEnabled: false,
  },
]

export const guineaContextDetails = {
  brandId: 19,
  drawGroupId: 7,
}

export const sierraLeoneContextDetails = {
  brandId: 18,
}

export const maliContextDetails = {
  brandId: 8,
}

export const cameroonContextDetails = {
  brandId: 6,
}

export const mozambiqueTaxRate = 0.15

export const maxTextInputLength = 155

export const desktopAppPortKey = 'lotto-desktop-app-port'

export const minPasswordLength = 6
export const maxPasswordLength = 100

export const sportRadar = window.srtmCommands

export const isStatisticsAvailable = true

export const debugMode = process.env.NODE_ENV === 'development' || process.env.REACT_APP_BRAND_OVERWRITE

type GlobalSettings = {
  turnstileCaptchaEnabled: boolean
}

export const globalSettings: GlobalSettings = {
  turnstileCaptchaEnabled: true,
}

export const CLIENT_MENU_OPTIONS = [
  'deposit-withdrawal',
  'transaction-history',
  'bet-history',
  'user-profile',
  'inbox',
  'logout',
] as const
